import {
  PublicClientApplication,
  type Configuration,
  type RedirectRequest,
  LogLevel,
} from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || '00000000-0000-0000-0000-000000000000';
const clientId = import.meta.env.VITE_AZURE_WEB_CLIENT_ID || '00000000-0000-0000-0000-000000000000';
const apiScope = import.meta.env.VITE_API_SCOPE || 'api://00000000-0000-0000-0000-000000000000/access_as_user';

const configuration: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // sessionStorage: tokens vinculados a la pestaña, no persistentes.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
      piiLoggingEnabled: false,
    },
  },
};

export const msalInstance = new PublicClientApplication(configuration);
await msalInstance.initialize();

export const loginRequest: RedirectRequest = {
  scopes: [apiScope, 'openid', 'profile'],
};
